export const CHANGE_NAME = 'CHANGE_NAME';
export const ADD_IMAGES = 'ADD_IMAGES';
export const SELECT_IMAGE = 'SELECT_IMAGE';
export const DELETE_IMAGE = 'DELETE_IMAGE';

export const DES_SELECT_IMAGE = 'DES_SELECT_IMAGE';
export const EDITING_IMAGE_NAME = 'EDITING_IMAGE';
export const CLOSE_EDITING_IMAGE = 'CLOSE_EDITING_IMAGE';
export const RESET_IMAGES = 'RESET_IMAGES';

// Interfaces
export interface ImageData {
    id: string;
    name?: string;
    width: number;
    height: number;
    size: number;
    src: string;
    active: boolean;
    changeName: boolean;
    origin: { x: number; y: number };
}

export interface AddImageAction {
    type: string;
    payload: ImageData[];
}

export type ImageDataCRUD = Pick<ImageData, 'id' | 'name'>;

export interface ImageCRUD {
    type: string;
    payload: ImageDataCRUD;
}

// Constantes de las acciones
export const AddImage = (payload: ImageData[]): AddImageAction => {
    return {
        type: ADD_IMAGES,
        payload,
    };
};

/**
 * Nos ayuda a cambiar el nombre de las cards de imágenes
 * @param payload \{ id: string, name: string }
 */
export const ChangeImageName = (payload: ImageDataCRUD): ImageCRUD => {
    return {
        type: CHANGE_NAME,
        payload,
    };
};
/**
 * Nos ayuda a seleccionar el nombre para editarlo
 * @param payload \{ id: string }
 */
export const EditingImageName = (payload: ImageDataCRUD): ImageCRUD => {
    return {
        type: EDITING_IMAGE_NAME,
        payload,
    };
};

/**
 * Ayuda a cerrar el input de edición del nombre
 */
export const CloseEditingImage = () => {
    return {
        type: CLOSE_EDITING_IMAGE,
    };
};

/**
 * Nos ayuda a seleccionar una imagen
 */
export const SelectImage = (payload: ImageDataCRUD): ImageCRUD => {
    return {
        type: SELECT_IMAGE,
        payload,
    };
};

/**
 * Nos ayuda a des-seleccionar una imagen
 */
export const DesSelectImage = () => {
    return {
        type: DES_SELECT_IMAGE,
    };
};
/**
 * Nos ayuda a borrar una imagen
 * @param payload \{ id: string }
 */
export const DeleteImage = (payload: ImageDataCRUD): ImageCRUD => {
    return {
        type: DELETE_IMAGE,
        payload,
    };
};
/**
 * El reset local de animaciones
 */
export const ResetImage = () => {
    return {
        type: RESET_IMAGES,
    };
};
